// extracted by mini-css-extract-plugin
export default {"controlsWrapper":"GoogleCharts_controlsWrapper__cluHg","info":"GoogleCharts_info__9hcoI","chart":"GoogleCharts_chart__sKn8L"};